<script>
import MyReasons from './MyReasons.vue';
import MyProgram from './MyProgram.vue';
// import MyWhatDos from './MyWhatDos.vue';
import MyMindMovie from './MyMindMovie.vue';
import { getDates } from '@/services/DateServices';
import { getAllReasonsFromDbase } from '@/services/ReasonsServices';
import { getProgramFromDbase } from '@/services/ProgramServices';
// import { getWhatDosFromDbase } from '@/services/WhatDosServices';
import { isUserLoggedIn } from "@/services/UserServices";


export default {
  components: {
    MyReasons,
    MyProgram,
    // MyWhatDos,
    MyMindMovie,
  },
  data() {
    return {
      loading: true,

      uId: null,
      token: null,
      todayActual: null,
      view: 'reasons',

      reasons: null,
      program: null,
      whatDos: null,
    };
  },
  methods: {
    setView(view) {
      this.view = view;
      this.$cookies.set('lastViewedTab', view);
    },
    async hardReset(listOfThingsToUpdate) {
      this.loading = true;

      if (listOfThingsToUpdate.includes('reasons')) {
        this.reasons = await getAllReasonsFromDbase(this.uId, this.token); // get reasons
      }
      if (listOfThingsToUpdate.includes('program')) {
        this.program = await getProgramFromDbase(this.uId, this.token); // get program
      }
      // if (listOfThingsToUpdate.includes('whatDos')) {
      //   this.whatDos = await getWhatDosFromDbase(this.uId, this.token); // get whatDos
      // }

      this.loading = false;
    },
  },
  async created() {

    // if user auth has expired, then send to homepage to log in again
    if (!isUserLoggedIn()) {
      this.$router.push('/');
    } else {
      this.uId = localStorage.getItem('uId');
      this.token = localStorage.getItem('idToken');
    }

    // get todayActual
    const ta = getDates(null);
    this.todayActual = ta.todayActual;

    // set the last viewed tab (if any)
    if (this.$cookies.isKey('lastViewedTab')) {
      this.setView(this.$cookies.get('lastViewedTab'));
    }

    // get reasons, program, and whatDos
    // await this.hardReset(['reasons', 'program', 'whatDos']);
    await this.hardReset(['reasons', 'program']);

  }
}
</script>

<template>
  <div id="my-account" class="px-4">

    <!-- page header -->
    <div class="d-flex justify-space-between my-3 align-center">
      <h1 class="text-h5 my-3 font-weight-bold">My Account</h1>
      <v-btn v-if="view === 'reasons'" @click.prevent="hardReset(['reasons'])" size="x-small" color="grey">Refresh</v-btn>
      <v-btn v-else-if="view === 'program'" @click.prevent="hardReset(['program'])" size="x-small" color="grey">Refresh</v-btn>
      <v-btn v-if="view === 'whatDos'" @click.prevent="hardReset(['whatDos'])" size="x-small" color="grey">Refresh</v-btn>
    </div>

    <!-- in-page menu -->
    <v-tabs grow hide-slider>
      <v-tab :class="{ 'active': view === 'reasons' }" @click="setView('reasons')">
        Remember
      </v-tab>

      <v-tab :class="{ 'active': view === 'program' }" @click="setView('program')">
        Program
      </v-tab>

<!--      <v-tab :class="{ 'active': view === 'whatDos' }" @click="setView('whatDos')">-->
<!--        WhatDo-->
<!--      </v-tab>-->

      <v-tab :class="{ 'active': view === 'mindMovie' }" @click="setView('mindMovie')">
        MindMovie
      </v-tab>
    </v-tabs>


    <!-- where users can adjust their data -->
    <div v-if="loading" class="text-center mt-5 pt-5">
      <v-progress-circular :size="100" color="amber" indeterminate></v-progress-circular>
    </div>
    <div v-else>
      <!-- reasons/reminders -->
      <section v-if="view === 'reasons' && reasons">
        <MyReasons :uId="uId" :token="token" :todayActual="todayActual" :reasons="reasons" />
      </section>
      
      <!-- program -->
      <section v-if="view === 'program' && program">
        <MyProgram :uId="uId" :token="token" :todayActual="todayActual" :program="program" />
      </section>
      
      <!-- mindMovie -->
      <section v-if="view === 'mindMovie'">
        <MyMindMovie />
      </section>

    </div>    
  </div>
</template>

<style lang="scss" scoped>
#my-account {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 64px;
  @media screen and (min-width: 768px) {
    padding-left: 0;
    padding-right: 0;
    max-width: 600px;
    margin: 0 auto;
  }
}

button.v-tab {
  border: 2px solid black;
  border-radius: 20px;
}
button.v-tab.active {
  background-color: black;
  color: gold;
  font-weight: bold;
  text-decoration: underline;
}
</style>
